export default {
  // 共通
  common: {
    confirm: '確認',
    cancel: 'キャンセル',
    save: '保存',
    delete: '削除',
    edit: '編集',
    add: '追加',
    search: '検索',
    reset: 'リセット',
    export: 'エクスポート',
    import: 'インポート',
    upload: 'アップロード',
    download: 'ダウンロード',
    submit: '送信',
    back: '戻る',
    next: '次へ',
    previous: '前へ',
    close: '閉じる',
    refresh: '更新',
    loading: '読み込み中...',
    success: '操作成功',
    error: '操作失敗',
    warning: '警告',
    info: '情報'
  },
  
  // ログイン
  login: {
    title: 'ユーザーログイン',
    username: 'ユーザー名',
    password: 'パスワード',
    login: 'ログイン',
    logout: 'ログアウト',
    loginSuccess: 'ログイン成功',
    loginFailed: 'ログイン失敗',
    notLoggedIn: 'ログインしていません...',
    systemTitle: '清和環境技術・水素発生器管理システム',
    welcomeTitle: 'ようこそ - 水素発生器管理システム',
    usernameMinLength: 'ユーザー名は2文字以上である必要があります',
    passwordFormat: 'パスワード形式が正しくありません',
    verificationCode: '認証コードエラー（大文字小文字を区別）'
  },
  
  // 管理ページ
  admin: {
    title: '清和環境技術-管理システム',
    dashboard: 'ダッシュボード',
    menu: 'メニュー',
    logout: 'ログアウト'
  },
  
  // デバイス管理
  device: {
    title: 'デバイス管理',
    list: 'デバイス一覧',
    add: 'デバイス追加',
    edit: 'デバイス編集',
    delete: 'デバイス削除',
    status: 'デバイス状態',
    type: 'デバイスタイプ',
    online: 'オンライン',
    offline: 'オフライン',
    heartbeat: 'ハートビートデータ',
    record: '操作記録',
    activate: 'アクティベーション記録',
    // 设备类型管理
    typeCode: 'デバイスタイプコード',
    typeName: 'デバイスタイプ名',
    selectOrganization: '組織を選択してください',
    typeCodePlaceholder: 'タイプコードを入力してください',
    typeNamePlaceholder: 'デバイスタイプ名を入力してください',
    typeCodeRequired: 'タイプコードは必須です',
    typeNameRequired: 'タイプ名は必須です',
    addType: 'タイプを追加',
    editType: 'タイプを編集',
    deleteConfirm: 'デバイスタイプ "{name}" を削除してもよろしいですか？',
    deleteSuccess: '削除成功',
    deleteFailed: '削除失敗',
    saveSuccess: '保存成功',
    saveFailed: '保存失敗',
    getDataFailed: 'データの取得に失敗しました',
    organization: '組織',
    universal: 'ユニバーサル',
    defaultOutVol: 'デフォルト出力量（鉱機）',
    outVolRequired: 'デフォルト出力量は必須です',
    changeRule: 'フィルター交換計算ルール',
    filterAlgorithm: 'フィルターアルゴリズム',
    byVolume: '流量で',
    byTime: '時間で',
    none: 'なし',
    ruleDescription: 'フィルター交換計算ルール：',
    volumeRule: '1：流量で計算（例：1-4号芯、40000Lごとに交換）',
    timeRule: '2：時間で計算（例：1年、60000L）',
    validHot: '初回温水',
    validHotYes: 'はい',
    validHotNo: 'いいえ',
    changeValue: 'フィルター交換値',
    changeValuePlaceholder: 'フィルター交換値を入力してください',
    changeValueUnit: '単位',
    changeValueUnitMl: 'ml',
    changeValueUnitYear: '年',
    customSettings: 'カスタム設定',
    settingKey: 'キー',
    settingValue: '値',
    settingRemark: '備考',
    settingKeyPlaceholder: 'キーを入力してください',
    settingValuePlaceholder: '値を入力してください',
    settingRemarkPlaceholder: '備考を入力してください',
    addSettingRow: '行を追加',
    deleteSettingRow: '削除',
    relatedOrg: '関連組織',
    remark: '備考'
  },
  
  // 組織管理
  org: {
    title: '組織管理',
    list: '組織一覧',
    add: '組織追加',
    edit: '組織編集',
    delete: '組織削除',
    name: '組織名',
    code: '組織コード',
    type: '組織タイプ'
  },
  
  // 水カード管理
  card: {
    title: '水カード管理',
    list: '水カード一覧',
    add: '水カード追加',
    bind: '水カードバインド',
    unbind: '水カードアンバインド',
    import: '水カードインポート',
    export: '水カードエクスポート',
    serialNo: 'シリアル番号',
    cardNo: 'カード番号',
    status: '状態'
  },
  
  // システム設定
  setting: {
    title: 'システム設定',
    general: '一般設定',
    security: 'セキュリティ設定',
    notification: '通知設定'
  },
  
  // データ統計
  stats: {
    title: 'データ統計',
    tds: 'TDS統計',
    volume: '水量統計',
    usage: '使用統計'
  },
  
  // フッター
  footer: {
    copyright: '© 2023 - 清和環境科技有限公司 全著作権所有',
    icp: 'ICP記録：',
    techSupport: '© 技術サポート：広州冠君水素技術有限公司'
  },
  
  // エラーメッセージ
  error: {
    network: 'ネットワークエラー',
    server: 'サーバーエラー',
    permission: '権限不足',
    param: 'パラメータエラー',
    notFound: 'データが存在しません',
    pageNotFound: '申し訳ございませんが、アクセスしたページは存在しません'
  },
  
  // メニュー関連
  menu: {
    // デバイス管理
    equipment: 'デバイス・フィルターライブラリ',
    filterRecord: 'フィルター交換記録',
    version: 'ホームバージョンライブラリ',
    dataQuery: 'TCPデータクエリ',
    heartbeat: 'ハートビートデータ',
    singleUse: '単回使用データ',
    bindStats: 'バインディング統計',
    
    // 顧客管理
    customer: '顧客管理',
    agentCheck: 'エージェント審査',
    agentProfit: 'エージェント利益管理',
    promotionRoute: 'プロモーションルート設定',
    partyType: 'パーティータイプ管理',
    
    // MQTTデータクエリ
    mqttQuery: 'MQTTデータクエリ',
    statusQuery: 'ステータスクエリ',
    outputRecord: '出力記録クエリ',
    debug: 'デバイスデバッグページ',
    waterTotal: '総出水クエリ',
    
    // システム管理
    adminAccount: '管理者アカウント',
    deviceType: 'デバイスタイプ管理',
    defaultSettings: 'デフォルトシステム設定',
    flowConfig: '水流パーソナライゼーション',
    waterConfig: '温度水量設定',
    businessLog: 'ビジネスログ',
    
    // 支払い管理
    payment: '支払い管理',
    order: '注文管理',
    statistics: 'データ統計',
    waterPrice: '水量価格設定',
    recharge: 'チャージ'
  },

  // 甲方タイプ管理
  orgLibConfig: {
    title: '甲方タイプ管理',
    libName: '甲方名',
    libNamePlaceholder: '甲方タイプ名を入力してください',
    libLevel: '甲方レベル',
    allLevels: 'すべてのレベル',
    level: '級',
    typeId: 'タイプID',
    typeName: 'タイプ名',
    typeNamePlaceholder: 'タイプ名を入力してください',
    typeLevel: 'タイプレベル',
    parentType: '親タイプ',
    childCount: '子数',
    status: 'ステータス',
    enabled: '有効',
    disabled: '無効',
    unknown: '不明',
    none: 'なし',
    remark: '備考',
    remarkPlaceholder: '備考を入力してください',
    createTime: '作成時間',
    detail: '詳細',
    edit: '編集',
    add: '追加',
    delete: '削除',
    editType: 'タイプ編集',
    addSubType: 'サブタイプ追加',
    typeNameRequired: 'タイプ名を入力してください',
    typeLevelRequired: 'タイプレベルを選択してください',
    deleteConfirm: 'このタイプを削除してもよろしいですか？',
    deleteSuccess: '削除成功',
    deleteFailed: '削除失敗',
    addSuccess: '追加成功',
    updateSuccess: '更新成功',
    saveFailed: '保存失敗',
    getDataFailed: 'データ取得失敗',
    getDetailFailed: '詳細取得失敗',
    getParentFailed: '親ノード情報取得失敗',
    cannotEditRoot: 'ルートノードは編集できません',
    cannotDeleteRoot: 'ルートノードは削除できません',
    hasChildrenCannotDelete: 'このノードには子ノードがあるため削除できません',
    maxLevelReached: '最大8レベルまでサポート'
  },

  // バナー管理
  banner: {
    title: 'ホームページバナー管理',
    addBanner: 'バナー追加',
    editBanner: 'バナー編集',
    image: '画像',
    linkUrl: 'リンクURL',
    sort: 'ソート',
    status: 'ステータス',
    createTime: '作成時間',
    enabled: '有効',
    disabled: '無効',
    titlePlaceholder: 'バナータイトルを入力してください',
    titleRequired: 'バナータイトルは必須です',
    imageRequired: 'バナー画像をアップロードしてください',
    linkUrlPlaceholder: 'リンクURLを入力してください（オプション）',
    sortPlaceholder: 'ソート値を入力してください。数字が小さいほど前に表示されます',
    sortRequired: 'ソート値は必須です',
    remark: '備考',
    remarkPlaceholder: '備考を入力してください',
    uploadImage: '画像をアップロード',
    viewImage: '画像を表示',
    removeImage: '画像を削除',
    uploadTip: '推奨サイズ：1920x600px、JPG、PNG形式をサポート、ファイルサイズは5MB以下',
    uploadImageOnly: '画像ファイルのみアップロード可能です',
    uploadSizeLimit: '画像サイズは5MBを超えることはできません',
    uploadSuccess: 'アップロード成功',
    uploadFailed: 'アップロード失敗',
    noImage: '画像なし',
    deleteConfirm: 'このバナーを削除してもよろしいですか？',
    deleteSuccess: '削除成功',
    deleteFailed: '削除失敗',
    saveSuccess: '保存成功',
    saveFailed: '保存失敗',
    updateSuccess: '更新成功',
    updateFailed: '更新失敗',
    getListFailed: 'バナーリストの取得に失敗しました'
  },

  // 出水总量查询
  waterTTL: {
    title: '総出水クエリ',
    equipmentId: 'デバイスID',
    enterEquipmentId: 'デバイスIDを入力してください',
    organization: '所属組織',
    allOrganizations: 'すべての組織',
    equipmentIdColumn: 'デバイスID',
    orgNameColumn: '所属組織',
    volumeTTLColumn: '使用流量·ml',
    waterRecord: '出水記録',
    export: 'エクスポート',
    exportSuccess: 'エクスポート成功',
    exportFailed: 'エクスポート失敗',
    getDataFailed: 'データ取得失敗',
    getOrgListFailed: '組織リスト取得失敗'
  },

  // 微信支付日志管理
  payLog: {
    title: 'WeChat支払いログ管理',
    payLogTab: '支払いログ',
    performanceTab: 'パフォーマンス監視',
    statisticsTab: 'データ統計',
    orderNo: '注文番号',
    orderNoPlaceholder: '注文番号を入力してください',
    logType: 'ログタイプ',
    allTypes: 'すべて',
    logTypePay: '支払い',
    logTypeRefund: '返金',
    logTypeQuery: 'クエリ',
    logTypeCallback: 'コールバック',
    logLevel: 'ログレベル',
    allLevels: 'すべて',
    logLevelInfo: '情報',
    logLevelWarn: '警告',
    logLevelError: 'エラー',
    apiType: 'APIタイプ',
    apiTypeUnifiedOrder: '統一下注文',
    apiTypeQuery: '注文クエリ',
    apiTypeRefund: '返金申請',
    minDuration: '最小所要時間(ms)',
    maxDuration: '最大所要時間(ms)',
    startDate: '開始日',
    endDate: '終了日',
    startDatePlaceholder: '開始日',
    endDatePlaceholder: '終了日',
    viewDetail: '詳細を見る',
    export: 'エクスポート',
    exportSuccess: 'エクスポート成功',
    exportFailed: 'エクスポート失敗',
    dateRangeRequired: '統計日付範囲を選択してください',
    logDetail: 'ログ詳細',
    logContent: 'ログ内容',
    requestData: 'リクエストデータ',
    responseData: 'レスポンスデータ',
    errorMsg: 'エラーメッセージ',
    ipAddress: 'IPアドレス',
    createTime: '作成時間',
    duration: '所要時間(ms)',
    status: 'ステータス',
    statDate: '統計日',
    totalOrders: '総注文数',
    successOrders: '成功注文数',
    failedOrders: '失敗注文数',
    totalAmount: '総金額(元)',
    successAmount: '成功金額(元)',
    refundOrders: '返金注文数',
    refundAmount: '返金金額(元)',
    successRate: '成功率',
    getDataFailed: 'データ取得失敗'
  },

  // 水量価格設定
  waterPriceConfig: {
    title: '水量価格設定',
    configName: '設定名',
    configNamePlaceholder: '設定名を入力してください',
    configDesc: '設定説明',
    configDescPlaceholder: '設定説明を入力してください',
    waterVolume: '水量(L)',
    waterVolumePlaceholder: '水量を入力してください',
    basePrice: '基本価格(元/L)',
    basePricePlaceholder: '基本価格を入力してください',
    discount: '割引',
    discountPlaceholder: '割引を入力してください(0.01-1.00)',
    discountedUnitPrice: '割引後単価(元/L)',
    finalPrice: '最終価格(元)',
    sortOrder: '並び順',
    sortOrderPlaceholder: '並び順を入力してください',
    status: 'ステータス',
    allStatus: 'すべて',
    enabled: '有効',
    disabled: '無効',
    enable: '有効化',
    disable: '無効化',
    createTime: '作成時間',
    updateTime: '更新時間',
    createUser: '作成者',
    updateUser: '更新者',
    addConfig: '新規設定',
    editConfig: '設定編集',
    batchEnable: '一括有効化',
    batchDisable: '一括無効化',
    waterVolumeRequired: '水量を入力してください',
    waterVolumeMin: '水量は0より大きい必要があります',
    basePriceRequired: '基本価格を入力してください',
    basePriceMin: '基本価格は0以上である必要があります',
    discountRequired: '割引を入力してください',
    discountRange: '割引は0.01-1.00の間である必要があります',
    configNameRequired: '設定名を入力してください',
    deleteConfirm: 'この設定を削除してもよろしいですか？',
    deleteSuccess: '削除成功',
    deleteFailed: '削除失敗',
    saveSuccess: '保存成功',
    saveFailed: '保存失敗',
    updateSuccess: '更新成功',
    updateFailed: '更新失敗',
    statusChangeConfirm: 'この設定を{status}してもよろしいですか？',
    statusChangeSuccess: 'ステータス更新成功',
    statusChangeFailed: 'ステータス更新失敗',
    batchEnableConfirm: '選択した設定を一括有効化してもよろしいですか？',
    batchEnableSuccess: '一括有効化成功',
    batchEnableFailed: '一括有効化失敗',
    batchDisableConfirm: '選択した設定を一括無効化してもよろしいですか？',
    batchDisableSuccess: '一括無効化成功',
    batchDisableFailed: '一括無効化失敗',
    selectConfigs: '操作する設定を選択してください',
    getListFailed: '価格設定リストの取得に失敗しました'
  },

  // 温度水量設定
  waterConfig: {
    title: '温度水量設定',
    waterType: '水タイプ',
    allTypes: 'すべて',
    iceWater: '氷水',
    normalWater: '常温 water',
    water45: '45℃水',
    water75: '75℃水',
    water95: '95℃水',
    status: 'ステータス',
    allStatus: 'すべて',
    enabled: '有効',
    disabled: '無効',
    waterMl: '対応水量(ml)',
    waterMlPlaceholder: '対応水量を入力してください',
    waterMlRequired: '対応水量は必須です',
    sort: 'ソート',
    sortPlaceholder: 'ソート値を入力してください（数字が小さいほど前に表示されます）',
    typeName: '水タイプ',
    waterVolume: '対応水量',
    createTime: '作成時間',
    updateTime: '更新時間',
    addConfig: '設定追加',
    editConfig: '温度水量設定編集',
    addConfigTitle: '温度水量設定追加',
    typeRequired: '水タイプは必須です',
    duplicateError: 'この水タイプと対応水量の組み合わせは既に存在します！',
    deleteConfirm: '削除してもよろしいですか？削除後は復元できません！',
    statusConfirm: 'この設定を{status}してもよろしいですか？',
    deleteSuccess: '削除成功',
    deleteFailed: '削除失敗',
    saveSuccess: '保存成功',
    saveFailed: '保存失敗',
    statusUpdateSuccess: 'ステータス更新成功',
    statusUpdateFailed: 'ステータス更新失敗',
    getDataFailed: 'データ取得失敗'
  }
}
